import React, { useState, useEffect } from "react";

export const BudgetCategories = ({
  categories,
  budgetData,
  getChartData,
  clientTransactionsCategories,
  clientTransactionsSubCategories,
  updateTransactionsCategories,
  updateTransactionsSubCategories,
}) => {
  const [expandedCategories, setExpandedCategories] = useState([]);
  const [selectedCategories, setSelectedCategories] = useState([]);
  const [selectedSubcategories, setSelectedSubcategories] = useState([]);

  const toggleCategory = (categoryId) => {
    if (expandedCategories.includes(categoryId)) {
      setExpandedCategories(
        expandedCategories.filter((id) => id !== categoryId)
      );
    } else {
      setExpandedCategories([...expandedCategories, categoryId]);
    }
  };
  const handleCategoryCheckboxChange = (categoryId, hasSubCategories) => {
    const isSelected = selectedCategories.includes(categoryId);
    const updatedCategories = isSelected
      ? selectedCategories.filter((id) => id !== categoryId)
      : [...selectedCategories, categoryId];

    setSelectedCategories(updatedCategories);

    // Construct payload and call API
    const idToUpdate =
      clientTransactionsCategories &&
      clientTransactionsCategories.find(
        (item) => item.categoryId === categoryId
      );
    console.log("idToUpdate", idToUpdate);

    const payload = {
      id: idToUpdate && idToUpdate.id,
      data: {
        enable: !isSelected,
        deleted: isSelected,
      },
    };
    updateTransactionsCategories(payload);

    // If the category has no subcategories, don't expand it.
    if (!hasSubCategories) {
      setExpandedCategories(
        expandedCategories.filter((id) => id !== categoryId)
      );
    }
  };

  const handleSubcategoryCheckboxChange = (subCategoryId) => {
    const isSelected = selectedSubcategories.includes(subCategoryId);
    const updatedSubcategories = isSelected
      ? selectedSubcategories.filter((id) => id !== subCategoryId)
      : [...selectedSubcategories, subCategoryId];

    setSelectedSubcategories(updatedSubcategories);

    // Construct payload and call API
    const idToUpdate =
      clientTransactionsSubCategories &&
      clientTransactionsSubCategories.find(
        (item) => item.subCategoryId === subCategoryId
      );
    console.log("idToUpdate", idToUpdate);
    const payload = {
      id: idToUpdate && idToUpdate.id,
      data: {
        enable: !isSelected,
        deleted: isSelected,
      },
    };
    updateTransactionsSubCategories(payload);
  };

  const isCategoryDisabled = (categoryId) =>
    budgetData &&
    budgetData.some(
      (data) => data.categoryId === categoryId && data.subCategoryId === null
    );

  const isSubcategoryDisabled = (subCategoryId) =>
    budgetData &&
    budgetData.some((data) => data.subCategoryId === subCategoryId);

  const handleUpdateChart = () => {
    let payload = {
      categoryId: selectedCategories,
      subCategoryId: selectedSubcategories,
    };
    getChartData(payload);
  };
  useEffect(() => {
    if (clientTransactionsCategories) {
      const categoryIds =
        clientTransactionsCategories &&
        clientTransactionsCategories
          .filter((category) => category.enable === true) // Only enabled categories
          .map((category) => category.categoryId);
      setSelectedCategories(categoryIds);
    }
    console.log("clientTransactionsCategories", clientTransactionsCategories);
  }, [clientTransactionsCategories]);
  useEffect(() => {
    if (clientTransactionsSubCategories) {
      const subCategoryIds =
        clientTransactionsSubCategories &&
        clientTransactionsSubCategories
          .filter((category) => category.enable === true) // Only enabled categories
          .map((category) => category.subCategoryId);
      console.log(
        "clientTransactionsSubCategories",
        clientTransactionsSubCategories
      );
      setSelectedSubcategories(subCategoryIds);
    }
  }, [clientTransactionsSubCategories]);
  return (
    <div className="create-main-card-conatiner">
      {" "}
      <div>
        <div className="budget-chart-title">Hide Categories</div>
        {/*<div className="budget-category-container">
        {categories &&
          categories.map((category) => (
            <div key={category.id}>
              <div
                className="budget-hide-categories-card"
                style={{
                  cursor:
                    category.subCategories.length > 0 ? "pointer" : "default",
                }}
                onClick={() =>
                  category.subCategories.length > 0 &&
                  toggleCategory(category.id)
                }
              >
                <span className="category-open">
                  {category.subCategories.length > 0 &&
                    (expandedCategories.includes(category.id) ? "▼" : "▶")}{" "}
                </span>
                <input
                  type="checkbox"
                  checked={selectedCategories.includes(category.id)}
                  onChange={() =>
                    handleCategoryCheckboxChange(
                      category.id,
                      category.subCategories.length > 0
                    )
                  }
                  className={
                    isCategoryDisabled(category.id) ? "disbale-checkbox" : ""
                  }
                  disabled={isCategoryDisabled(category.id)}
                />
                <span
                  className={
                    isCategoryDisabled(category.id)
                      ? "category-name disbale-checkbox"
                      : "category-name"
                  }
                >
                  {category.categoryName}
                </span>
              </div>
              {expandedCategories &&
                expandedCategories.includes(category.id) &&
                category.subCategories.length > 0 && (
                  <div style={{ marginLeft: "20px" }}>
                    {category.subCategories.map((subCategory) => (
                      <div
                        key={subCategory.id}
                        style={{
                          display: "flex",
                          alignItems: "center",
                          marginTop: "4px",
                          gap: "6px",
                        }}
                      >
                        <input
                          type="checkbox"
                          checked={selectedSubcategories.includes(
                            subCategory.id
                          )}
                          onChange={() =>
                            handleSubcategoryCheckboxChange(subCategory.id)
                          }
                          className={
                            isSubcategoryDisabled(subCategory.id)
                              ? "disbale-checkbox"
                              : ""
                          }
                          disabled={isSubcategoryDisabled(subCategory.id)}
                        />
                        <span
                          className={
                            isSubcategoryDisabled(subCategory.id)
                              ? "category-name disbale-checkbox"
                              : "category-name"
                          }
                        >
                          {subCategory.name}
                        </span>
                      </div>
                    ))}
                  </div>
                )}
            </div>
          ))}
      </div> */}
        <div className="budget-category-container">
          {clientTransactionsCategories &&
            clientTransactionsCategories
              .filter((category) => category) // Only include enabled categories
              .map((category) => (
                <div key={category.id}>
                  <div
                    className="budget-hide-categories-card"
                    style={{
                      cursor: "pointer", // Allow click event for categories with subcategories
                    }}
                    onClick={() => toggleCategory(category.categoryId)} // Expand/collapse categories on click
                  >
                    <span className="category-open">
                      {expandedCategories.includes(category.categoryId)
                        ? "▼"
                        : "▶"}{" "}
                    </span>
                    <input
                      type="checkbox"
                      checked={selectedCategories.includes(category.categoryId)}
                      onChange={() =>
                        handleCategoryCheckboxChange(category.categoryId)
                      }
                      className={
                        isCategoryDisabled(category.id)
                          ? "disbale-checkbox"
                          : ""
                      }
                      disabled={isCategoryDisabled(category.categoryId)}
                    />
                    <span
                      className={
                        isCategoryDisabled(category.categoryId)
                          ? "category-name disbale-checkbox"
                          : "category-name"
                      }
                    >
                      {category.category.categoryName}
                    </span>
                  </div>

                  {/* Display Subcategories If Expanded */}
                  {expandedCategories.includes(category.categoryId) && (
                    <div style={{ marginLeft: "20px" }}>
                      {clientTransactionsSubCategories &&
                        clientTransactionsSubCategories
                          .filter(
                            (subCategory) =>
                              subCategory &&
                              subCategory.categoryId === category.categoryId // Match enabled subcategory to categoryId
                          ) // Match subcategory to category based on categoryId
                          .map((subCategory) => (
                            <div
                              key={subCategory.subCategoryId}
                              style={{
                                display: "flex",
                                alignItems: "center",
                                marginTop: "4px",
                                gap: "6px",
                              }}
                            >
                              <input
                                type="checkbox"
                                checked={selectedSubcategories.includes(
                                  subCategory.subCategoryId
                                )}
                                onChange={() =>
                                  handleSubcategoryCheckboxChange(
                                    subCategory.subCategoryId
                                  )
                                }
                                className={
                                  isSubcategoryDisabled(
                                    subCategory.subCategoryId
                                  )
                                    ? "disbale-checkbox"
                                    : ""
                                }
                                disabled={isSubcategoryDisabled(
                                  subCategory.subCategoryId
                                )}
                              />
                              <span
                                className={
                                  isSubcategoryDisabled(
                                    subCategory.subCategoryId
                                  )
                                    ? "category-name disbale-checkbox"
                                    : "category-name"
                                }
                              >
                                {subCategory.subCategory.name}
                              </span>
                            </div>
                          ))}
                    </div>
                  )}
                </div>
              ))}
        </div>
      </div>
      {/*<div className="budget-create-buttons-conatiner-single">
        <button
          className="budget-create-save"
          onClick={() => {
            handleUpdateChart();
          }}
        >
          Update
        </button>
      </div> */}
    </div>
  );
};
